import PropTypes from 'prop-types'
import React, { useState, useRef, useEffect, useCallback } from 'react'
import { getInputClasses } from '../../helpers/obtenerClasesInput'
import useError from '../hooks/useError'
import useWarning from '../hooks/useWarning'

// eslint-disable-next-line no-unused-vars
const InputEditable = React.forwardRef((props, ref) => {
  const {
    name,
    classLabel,
    classInput,
    disabled,
    texto,
    placeholder,
    onChange,
    onClickOutSide,
    onFocus,
    onFocusSelected,
    errores,
    warnings,
    ...rest
  } = props
  const { ShowError, hayError } = useError(errores, name)
  const { ShowWarning, hayWarning } = useWarning(warnings, name)

  const handleFocus = (event) => onFocusSelected && event.target.select()

  const inputRef = useRef(null)
  const [inputVisible, setInputVisible] = useState(false)
  const [text, setText] = useState(texto)

  const handleClickOutSide = useCallback(
    (e) => {
      if (inputRef.current && !inputRef.current.contains(e.target)) {
        onClickOutSide(e, name)
        setInputVisible(false)
      }
    },
    [onClickOutSide, name]
  )

  useEffect(() => {
    if (!inputVisible) return
    document.addEventListener('mousedown', handleClickOutSide)
    return () => {
      document.removeEventListener('mousedown', handleClickOutSide)
    }
  }, [inputVisible, handleClickOutSide])

  useEffect(() => {
    setText(texto)
  }, [texto])

  if (inputVisible) {
    return (
      <input
        {...rest}
        ref={inputRef}
        name={name}
        id={name}
        value={text}
        placeholder={placeholder}
        onChange={(e) => onChange(e.nativeEvent)}
        className={getInputClasses(classInput, { disabled, hayError, hayWarning })}
        autoFocus
        disabled={disabled}
        onFocus={onFocus ?? handleFocus}
        aria-disabled={disabled}
      />
    )
  }

  return (
    <>
      <span onClick={() => setInputVisible(true)} className={classLabel}>
        {text === '' ? placeholder : text}
      </span>
      <ShowError />
      <ShowWarning />
    </>
  )
})

InputEditable.defaultProps = {
  type: 'text'
}

InputEditable.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['text', 'email', 'date', 'number', 'password']),
  classLabel: PropTypes.string,
  classInput: PropTypes.string,
  disabled: PropTypes.bool,
  texto: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onClickOutSide: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onFocusSelected: PropTypes.bool,
  errores: PropTypes.object,
  warnings: PropTypes.object
}

InputEditable.displayName = 'InputEditable'

export default InputEditable
